/**
 * Onboarding (F1 — extração, ADR 0044): welcome → goal → account →
 * starter-transaction, + done (conclusão) e o cabeçalho compartilhado
 * (OnboardingHeader). Valores são as strings PT literais das telas.
 */
export const onboarding = {
    header: {
        backA11y: 'Voltar',
        skip: 'Pular',
    },
    welcome: {
        headline: 'Controle seus gastos.\nFácil assim.',
        subtitle: 'Responda 3 perguntas e o Kontto se monta do seu jeito.',
        startButton: 'Montar meu Kontto',
        effortNote: 'Leva menos de 1 minuto · sem cadastro',
        restoreButton: 'Já uso o Kontto · Restaurar',
        restoreA11y: 'Já uso o Kontto, restaurar',
        enterError: 'Falha ao entrar no app',
    },
    goal: {
        title: 'O que você quer resolver primeiro?',
        subtitle: 'Escolha quantos quiser. A gente monta seu Kontto em volta disso.',
        // Junções da barra de promessa; os rótulos vêm de lib/onboarding
        // (promiseLabel), fora deste namespace.
        promisePair: '{{first}} e {{second}}',
        promiseOverflow: '{{first}}, {{second}} e mais {{extra}}',
        promisePrefix: 'Seu Kontto vai priorizar ',
        promiseSuffix: '.',
        continueButton: 'Montar meu Kontto',
    },
    account: {
        title: 'De onde sai seu dinheiro?',
        subtitle: 'Escolha pra começar — é só pra identificar a conta, nada é conectado ao banco.',
        searchPlaceholder: 'Buscar banco',
        cashChip: 'Dinheiro',
        otherChip: 'Outro',
        searchEmpty: 'Nenhum banco com “{{query}}”. Toque em Pular pra usar uma carteira de dinheiro.',
        continueButton: 'Continuar',
        createError: 'Falha ao criar a conta',
    },
    starter: {
        skip: 'Pular',
        eyebrow: 'ÚLTIMO PASSO',
        title: 'Qual foi seu\núltimo gasto?',
        subtitle: 'Chuta o valor — dá pra editar depois.',
        categoryQuestion: 'Com o quê?',
        moreCategories: 'Outros',
        moreCategoriesA11y: 'Outras categorias',
        saveButton: 'Salvar meu 1º gasto',
        saveA11y: 'Salvar primeiro gasto',
        saveError: 'Não foi possível salvar',
    },
    done: {
        headline: 'Tudo pronto. O controle é seu 🎉',
        subtitle: 'Seu Kontto está montado do seu jeito — sem cadastro, no seu aparelho. Bora começar.',
        reminders: {
            title: 'Ativar lembretes',
            description: 'Avisos de vencimento e de inatividade pra não esquecer nenhuma conta.',
            button: 'Ativar lembretes',
            grantedTitle: 'Lembretes ativados',
            grantedMessage: 'Avisamos você antes de cada vencimento.',
            deniedTitle: 'Tudo bem',
            deniedMessage: 'Você pode ativar quando quiser em Ajustes › Lembretes.',
        },
        pro: {
            title: 'Conheça o Kontto Pro',
            description: 'Relatórios avançados, sem limites e mais — dá uma olhada quando quiser.',
        },
        enterButton: 'Ir pro app',
    },
    // Foco (tela de personalização) + personalização do Dia-0 — textos consumidos por
    // lib/onboarding.ts (onboardingFocusOptions / goalPersonalization). Os campos
    // estruturais (id, goal, firstStepPriority, actionRoute) ficam no lib, fora do i18n.
    focus: {
        reports: { label: 'Pra onde vai meu dinheiro', planLine: 'Gastos por categoria, no detalhe', promiseLabel: 'pra onde vai o dinheiro' },
        budget: { label: 'Não estourar o mês', planLine: 'Orçamentos com alerta antes de estourar', promiseLabel: 'não estourar o mês' },
        bills: { label: 'Faturas e contas em dia', planLine: 'Avisos de vencimento de cada conta', promiseLabel: 'contas em dia' },
        goal: { label: 'Juntar pra uma meta', planLine: 'Uma meta com valor e prazo claros', promiseLabel: 'sua meta' },
        export: { label: 'Ter tudo num relatório', planLine: 'Relatório em PDF e planilha', promiseLabel: 'relatórios' },
    },
    // A headline conversa com o 3º passo do checklist de cada caminho (ADR 0071).
    personalization: {
        'control-spending': { homeHeadline: 'Bora não estourar o mês: crie seu primeiro orçamento.', offerLead: 'Pra controlar seus gastos de perto' },
        'plan-the-month': { homeHeadline: 'Cadastre seu cartão e veja pra onde vai seu dinheiro.', offerLead: 'Pra enxergar pra onde vai seu dinheiro' },
        'organize-cards': { homeHeadline: 'Bora organizar seus cartões: cadastre o primeiro.', offerLead: 'Pra manter seus cartões e faturas no controle' },
        'save-for-a-goal': { homeHeadline: 'Bora juntar pra sua meta: crie a primeira.', offerLead: 'Pra você juntar dinheiro pra sua meta' },
        'automate-android': { homeHeadline: 'Ligue a leitura automática e o Kontto anota por você.', offerLead: 'Pra anotar seus gastos sem esforço' },
    },
};
